<div class="grid-container">
  <div class="grid-item" *ngFor="let item of imageSrcs">
    <div class="image-wrapper">
      <div *ngIf="item.label" class="mb-4">{{ item.label }}</div>
      <div *ngIf="!item.label" class="py-4"></div>
      <img [src]="item.src" [alt]="item.label" class="zoom"/>
    </div>
  </div>
</div>
